import { Link } from "react-router-dom";
import { ArrowUpRight, Globe, MapPin, Search, Sparkles, Cpu, MessageCircle, IdCard, ShieldCheck } from "lucide-react";
import { SERVICE_PAGES } from "@/lib/servicePages";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ICONS = [Globe, MapPin, Search, Sparkles, Cpu, MessageCircle, IdCard, ShieldCheck];

export const MainServices = ({ onConsult }) => (
  <section id="services" className="relative py-24 sm:py-32" data-testid="main-services-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow index="01">Our services</Eyebrow>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-6xl">
          Everything your business needs <span className="text-slate-400">to grow online.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
        {SERVICE_PAGES.filter((p) => !p.ownSection).map((p, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={p.slug} delay={(i % 4) * 0.06}>
              <article className="spot-card group flex h-full flex-col rounded-3xl border border-white/10 bg-[#0E1526] p-6" data-testid={`main-service-${p.slug}`}>
                <Icon className="h-6 w-6 text-[#00F0FF]" />
                <h3 className="mt-6 font-display text-lg font-bold leading-snug text-white">{p.name}</h3>
                <p className="mt-2 line-clamp-3 text-sm text-slate-300">{p.what}</p>
                <div className="mt-auto flex flex-col gap-2 pt-6">
                  <Link to={`/services/${p.slug}`} data-testid={`main-service-${p.slug}-link`} className="flex items-center gap-1 text-sm font-semibold text-[#00F0FF] hover:underline">
                    Learn more <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
                  </Link>
                  <button onClick={() => onConsult(p.consult, "main_service")} data-testid={`main-service-${p.slug}-consult`} className="w-fit text-left text-sm text-slate-300 hover:text-white">Book Free Consultation</button>
                </div>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
